var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { utils } from '../utils/utils';
import { HttpActionResult } from './http_action_result';
import { HttpMethod } from './http_method';
import { HttpRequest } from './http_request';
var HttpResponseError = /** @class */ (function (_super) {
    __extends(HttpResponseError, _super);
    function HttpResponseError(status, message) {
        var _this = _super.call(this, message) || this;
        _this.status = status;
        return _this;
    }
    return HttpResponseError;
}(Error));
export { HttpResponseError };
var HttpClient = /** @class */ (function () {
    function HttpClient() {
        this.defaultHeaders = {};
        this.customPayload = undefined;
    }
    Object.defineProperty(HttpClient.prototype, "responseBody", {
        /** Gets the response body for the latest request  */
        get: function () {
            return this._responseBody;
        },
        enumerable: true,
        configurable: true
    });
    HttpClient.prototype.get = function (url, options) {
        return this.send(HttpMethod.Get, url, null, options);
    };
    HttpClient.prototype.post = function (url, data, options) {
        return this.send(HttpMethod.Post, url, data, options);
    };
    HttpClient.prototype.put = function (url, data, options) {
        return this.send(HttpMethod.Put, url, data, options);
    };
    HttpClient.prototype.delete = function (url, data, options) {
        return this.send(HttpMethod.Delete, url, data, options);
    };
    HttpClient.prototype.send = function (method, url, data, options) {
        var _this = this;
        options = options || {};
        var dataType = options.dataType || 'json';
        var contentType = options.contentType || (dataType !== 'form-data')
            ? 'application/json'
            : null;
        if (data && dataType != 'form-data' && this.customPayload) {
            data.data = utils.assignDeep(data.data || {}, this.customPayload);
        }
        var XHR = ('onload' in new XMLHttpRequest())
            ? XMLHttpRequest
            : window["XDomainRequest"]; //IE support
        var xhr = new XHR();
        var desc = {
            method: method,
            url: url,
            headers: __assign(__assign({}, this.defaultHeaders), options.headers || {}),
            queryParams: options.queryParams || {},
            data: data
        };
        if (contentType)
            desc.headers['Content-Type'] = contentType;
        var request = new HttpRequest(xhr, desc);
        if (this.beforeEachRequest) {
            console.warn("HttpClient: 'beforeEachRequest' is deprecated and will be removed in future updates.\n            Use 'onRequest' instead");
            this.beforeEachRequest(request);
        }
        if (this.onRequest) {
            this.onRequest(request);
        }
        var dataToSend = (request.data && typeof request.data !== 'string'
            && dataType == 'json')
            ? JSON.stringify(request.data)
            : request.data;
        request.open();
        return new HttpActionResult(request, new Promise(function (resolve, reject) {
            if (options.responseType)
                xhr.responseType = options.responseType;
            xhr.onerror = function (error) {
                reject(new HttpResponseError(xhr.status, xhr.responseText));
            };
            xhr.onreadystatechange = function () {
                if (xhr.readyState != 4)
                    return; //we process only the state change to DONE(4)
                var responseContentType = xhr.getResponseHeader('Content-Type') || '';
                var status = xhr.status;
                if (status === 0) {
                    reject(new HttpResponseError(status, "Network error or the request was aborted"));
                }
                else if (status >= 200 && status < 400) {
                    //Success
                    var responseObj = (xhr.responseType === 'arraybuffer' || xhr.responseType === 'blob')
                        ? xhr.response
                        : (responseContentType.indexOf('application/json') == 0
                            ? JSON.parse(xhr.responseText)
                            : xhr.responseText);
                    _this._responseBody = responseObj;
                    if (_this.onResponse) {
                        _this.onResponse(xhr);
                    }
                    resolve(responseObj);
                }
                else {
                    //Error
                    var rtPromise = (xhr.responseType === 'arraybuffer' || xhr.responseType === 'blob')
                        ? HttpClient.decodeArrayBuffer(xhr.response)
                        : Promise.resolve(xhr.responseText);
                    rtPromise.then(function (responseText) {
                        var responseObj = (responseContentType.indexOf('application/json') == 0)
                            ? JSON.parse(responseText)
                            : responseText;
                        _this._responseBody = responseObj;
                        var message = responseObj.message ||
                            (status == 404
                                ? "No such endpoint: " + url
                                : responseObj);
                        reject(new HttpResponseError(status, message));
                    });
                }
            };
            xhr.send(dataToSend);
        }));
    };
    HttpClient.decodeArrayBuffer = function (uintArray) {
        var reader = new FileReader();
        return new Promise(function (resolve) {
            reader.onloadend = function () {
                if (reader.readyState == FileReader.DONE) {
                    resolve(reader.result);
                }
            };
            reader.readAsText(new Blob([uintArray]));
        });
    };
    return HttpClient;
}());
export { HttpClient };
//# sourceMappingURL=http_client.js.map